import React, { useCallback } from 'react'
import { MenuDelete, MenuEdit, MenuItem } from '../../../../../../shared/menu/menu'
import { IconActivityLog, IconAnalytic, IconAssessment, IconAuthLogin, IconAuthSession, IconContent, IconGroup } from '../../../../../../shared/icon/icon'
import { useAuditCapabilities } from '../../../../../../shared/audit/use-audit-capabilities'
import { useRoleOrgGroupUser, useRoleOrgNodeUser, useRoleOrgUser } from '../../../../../../role/hook/role-org'

// One user's menu, shared by the Users grid's row menu and the user page's
// header menu so the two can't drift: the same items, in the same order,
// with the same permissions. The row menu adds Edit first ({ edit: true }),
// which opens the user page. Paths are absolute, so the page menu works the
// same from any of the user's sub-pages.
//
// Returns (userID, { edit }) => [elements], to pass to <Menu> as children
// (Menu reads each child's props, so the items can't be wrapped).
export const useUserMenuItems = () => {
  const roleOrgUser = useRoleOrgUser()
  const roleOrgNodeUser = useRoleOrgNodeUser()
  const roleOrgGroupUser = useRoleOrgGroupUser()
  const caps = useAuditCapabilities()

  return useCallback(
    (userID, { edit = false } = {}) => {
      const base = `/org/user/list/edit/${userID}`
      const list = [
        <MenuItem key="contents" Icon={IconContent} text="contents" to={`${base}/content`} show={roleOrgNodeUser.accessRead} />,
        <MenuItem key="groups" Icon={IconGroup} text="groups" to={`${base}/group`} show={roleOrgGroupUser.accessRead} />,
        <MenuItem key="analytics-custom" Icon={IconAnalytic} text="analytics custom" to={`${base}/analytic-custom`} show={roleOrgGroupUser.accessRead} />,
        <MenuItem key="analytics-general" Icon={IconAnalytic} text="analytics general" to={`${base}/analytic-general`} show={roleOrgGroupUser.accessRead} />,
        <MenuItem key="assessments" Icon={IconAssessment} text="assessments" to={`${base}/assessment-reports`} show={roleOrgGroupUser.accessRead} />,
        <MenuItem key="auth-sessions" Icon={IconAuthSession} text="auth sessions" to={`${base}/auth-session`} show={roleOrgGroupUser.accessRead} />,
        <MenuItem key="sign-in-history" Icon={IconAuthLogin} text="sign-in history" to={`${base}/activity?cat=sign_ins`} show={caps.canAudit} />,
        <MenuItem key="activity" Icon={IconActivityLog} text="activity" to={`${base}/activity`} show={caps.canAudit} />,
        <MenuDelete key="delete" to={`${base}/delete`} show={roleOrgUser.accessDelete} />
      ]
      return edit ? [<MenuEdit key="edit" to={base} show={roleOrgUser.accessRead} />, ...list] : list
    },
    [roleOrgUser, roleOrgNodeUser, roleOrgGroupUser, caps]
  )
}
